import type { MessageMentionReference } from "@/lib/message-mention-link";

function normalizeValue(value: string | null): string {
  return value?.trim() ?? "";
}

export function findMentionElement(target: EventTarget | null): HTMLElement | null {
  if (!(target instanceof Element)) {
    return null;
  }

  const mentionElement = target.closest<HTMLElement>("[data-mention-type]");
  return mentionElement instanceof HTMLElement ? mentionElement : null;
}

export function readMentionReferenceFromElement(
  element: Element | null | undefined
): MessageMentionReference | null {
  if (!element) return null;

  const id = normalizeValue(
    element.getAttribute("data-mention-id") ?? element.getAttribute("data-id")
  );
  const mentionType = normalizeValue(element.getAttribute("data-mention-type"));

  if (!id || !mentionType) {
    return null;
  }

  return { id, mentionType };
}
